<template>
  <div :class="{ 'featured-book-listing': !is_combine }" id="featured-book">
    <div class="featured-books infinite-scroll">
      <div class="item-list">
        <div
          v-for="book in bookList"
          :key="book.id"
          class="col-md-4 col-sm-6 col-xs-12 no-padding no-margin featured-wraper"
          style="margin-bottom: 20px"
        >
          <div class="featured-book three-grid">
            <div class="featured-book-image">
              <a :href="showUrl(book.slug)">
                <img
                  v-bind:src="getImageUrl(book)"
                  :alt="book.tite"
                  class="clip-image lazyload"
                  width="100%"
                  height="100%"
                />
              </a>
              <div v-if="is_admin" class="featured-book-image-overlay">
                <div class="image-overlay-header">
                  <a
                    v-if="permittedUser() || isOwner(book)"
                    :href="deleteUrl(book.id)"
                    :data-token-1="'haggadah-' + book.id"
                    v-bind:data-name="book.title"
                    data-method="delete"
                    v-bind:data-token="csrf_token"
                    data-confirm="Are you sure?"
                    class="action_confirm"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </a>
                  <a v-if="is_admin == 1" href>
                    <i class="fa fa-cog" @click.prevent="showModal(book)"></i>
                  </a>
                </div>
                <div class="image-overlay-buttons text-center">
                  <div v-if="isOwner(book) || is_admin">
                    <a
                      :href="editUrl(book.slug)"
                      class="colorWhite brandon_grotesque_medium btn-font-big btn btn-lg btn-secondary"
                      >Edit</a
                    >
                    <a
                      :href="showUrl(book.slug)"
                      class="colorWhite brandon_grotesque_medium btn-font-big btn btn-lg btn-primary-color"
                      >View</a
                    >
                  </div>
                  <div v-else>
                    <span>&nbsp;</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="book-details">
              <div class="book-details-container">
                <div class="title-section text-center">
                  <div class="book-title">
                    <h3>
                      <a :href="showUrl(book.slug)">{{
                        $options.filters.getWords(book.title, 5, "...")
                      }}</a>
                    </h3>
                  </div>
                  <div class="book-author text-capitalize">
                    <a
                      v-if="book.user.user_type === '0'"
                      :href="userUrl(book.user.slug)"
                    >
                      by
                      {{ book.user.first_name }}
                    </a>
                    <a v-else :href="userUrl(book.user.slug)">
                      by
                      {{ book.user.first_name }} {{ book.user.last_name }}
                    </a>
                  </div>
                </div>
                <div class="book-cotnent">{{ book.covertext }}</div>
              </div>
              <div class="book-meta">
                <ul>
                  <li class="pull-left">
                    <a
                      :href="showUrl(book.slug)"
                      class="btn view-btn text-capitalize"
                    >
                      <i class="fa fa-search"></i>
                      View {{ trans("book.singular") }}
                    </a>
                  </li>
                  <li class="pull-right">
                    <div v-if="loggedInUser()">
                      <div v-if="current_user.id == book.user_id">
                        <a
                          :href="editUrl(book.slug)"
                          class="list-action btn btn-dark"
                        >
                          <i class="fa fa-pencil"></i>
                          <span class="text-capitalize"
                            >Edit {{ trans("book.singular") }}</span
                          >
                        </a>
                      </div>
                      <div v-else>
                        <save-book
                          :book="book.id"
                          :saved="checkSavedBook(book.id)"
                        ></save-book>
                      </div>
                    </div>
                    <div v-else>
                      <a
                        href="/user/login"
                        class="list-action-guest btn btn-dark"
                        id="Login"
                        data-toggle="modal"
                        data-keyboard="true"
                        data-target="#loginModal"
                        data-type="SaveBook"
                        :data-id="book.id"
                      >
                        <i class="fa fa-star"></i>
                        <span class="text-capitalize"
                          >Save {{ trans("book.singular") }}</span
                        >
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!is_combine" class="clearfix"></div>
    <div v-if="type == 'book_search'">
      <div v-if="busy === true" class="row">
        <div class="col-md-12 text-center loader-section">
          <p>
            <img src="/themes/front/img/loading.gif" alt="loading" />
          </p>
          <p>
            <small>Loading Content</small>
          </p>
        </div>
      </div>
      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="10"
      ></div>
    </div>
    <div
      id="setting-haggadah"
      class="modal fade text-left"
      :class="haggadahsettingModalClass"
      tabindex="-1"
      role="dialog"
    >
      <div class="setting modal-dialog">
        <!-- Modal content-->
        <div class="overlay-title">
          <h1 class="text-capitalize">Settings {{ trans("book.singular") }}</h1>
        </div>
        <div class="setting modal-content">
          <div class="setting modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="closeModal"
            >
              <i class="fa fa-times"></i>
            </button>
            <h2 class="title">{{ current_book.title }}</h2>
            <hr />
            <h3 class="text-capitalize">
              {{ trans("book.singular") }} privacy options
            </h3>
            <br />
            <p>
              Select public allows other Haggadot Community members to use your
              public {{ trans("clip.singular") }} in their
              {{ trans("book.Multiple") }}.
            </p>
            <br />

            <div class="row custom-radio-section">
              <div class="col-sm-3">
                <input
                  type="radio"
                  class="field"
                  name="is_public"
                  id="featured_public_radio"
                  value="1"
                  :checked="current_book.is_public == 1"
                />
                <label for="featured_public_radio">Public</label>
              </div>
              <div class="col-sm-3">
                <input
                  type="radio"
                  class="field"
                  name="is_public"
                  id="featured_private_radio"
                  value="0"
                  :checked="current_book.is_public == 0"
                />
                <label for="featured_private_radio">Private</label>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 custom-checkbox-section">
                <input
                  type="checkbox"
                  class="field"
                  name="is_featured"
                  :value="1"
                  id="partner_featured_checkbox"
                  :checked="current_book.is_featured == 1"
                />
                <label for="partner_featured_checkbox">Make Feature</label>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="reading-list col-md-12">
                <input
                  type="button"
                  value="SAVE"
                  class="setting-btn colorWhite brandon_grotesque_medium btn-font-big btn btn-lg btn-primary-color"
                  @click="updateBookSetting()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="haggadahsettingModalClass"
      class="modal-backdrop fade"
      :class="haggadahsettingModalClass"
    ></div>
  </div>
</template>


<script>
import infiniteScroll from "vue-infinite-scroll";

var count = 0;
export default {
  props: [
    "current_user",
    "bookList",
    "myBookList",
    "page",
    "token",
    "is_admin",
    "type",
    "is_combine",
  ],
  directives: { infiniteScroll },
  data() {
    return {
      csrf_token: this.token,
      books: this.bookList,
      loggedin_user: this.current_user,
      data: [],
      busy: false,
      allfatched: false,
      haggadahsettingModalClass: "",
      current_book: [],
    };
  },
  computed: {},
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    getWords: function (value, return_words, last_word = "") {
      if (!value) return "";
      value.replace("\n", "");
      //Split the word from the space or tab
      var title_arr = value.split(/\s+/);
      if (title_arr.length > return_words) {
        value = title_arr.slice(0, return_words).join(" ") + last_word;
      }
      return value;
    },
  },
  methods: {
    showUrl(book_id) {
      return this.route("user.book.show", { slug: book_id });
    },
    editUrl(book_id) {
      return this.route("user.book.edit", { slug: book_id });
    },
    userUrl(slug) {
      return this.route("user.show", { slug: slug });
    },
    deleteUrl(book_id) {
      return this.route("user.book.destroy", { id: book_id });
    },
    getImageUrl(book) {
      // Get all media list
      var book_images = book.media.filter(function (image, index) {
        if (image.collection_name === "book_image") {
          return image;
        }
      });

      // take last image
      // let last_image = book_images[book_images.length-1];

      // if(last_image){
      // 	// var base_path = "/uploads"+"/"+last_image.disk+"/"+last_image.id+"/"+last_image.file_name;
      // 	var base_path = "/uploads"+"/"+last_image.disk+"/"+last_image.id+"/conversions/preview.jpg";

      // 	// var status = this.UrlExists(base_path) // Check the image is exist or not
      // 	// if(status){
      // 		return base_path;
      // 	// }
      // }
      var default_image_path = book.default_book_image;

      return default_image_path;
    },
    UrlExists(url) {
      var http = new XMLHttpRequest();
      http.open("HEAD", url, false);
      http.send();
      return http.status != 404;
    },
    loggedInUser() {
      if (this.current_user) {
        return true;
      }
      return false;
    },
    permittedUser() {
      if (this.is_admin) {
        return true;
      }
      return false;
    },
    isOwner(book) {
      if (this.loggedin_user.id === book.user_id) {
        return true;
      }
      return false;
    },
    closeModal() {
      this.current_book = [];
      this.haggadahsettingModalClass = "";
    },
    showModal(book) {
      this.current_book = book;
      this.haggadahsettingModalClass = "in";
    },
    updateBookSetting() {
      var is_public = $('.setting input[name="is_public"]:checked').val() || 0;
      var is_featured =
        $('.setting input[name="is_featured"]:checked').val() || 0;
      axios
        .patch(
          this.route("user.book.updateSetting", { id: this.current_book.id }),
          {
            is_public: is_public,
            is_featured: is_featured,
          }
        )
        .then((response) => {
          this.closeModal();
          location.reload();
        })
        .catch();
    },
    loadMore: function () {
      var vm = this; //declare this
      var list = [];
      if (vm.allfatched !== true) {
        this.busy = true;
        count++;
        var url = window.location.href;
        if (url.indexOf("?") == -1) {
          url += "?";
        } else {
          url += "&";
        }
        url += "page=" + count;
        console.log(url);
        setTimeout(() => {
          axios.get(url).then((response) => {
            if (response.data.length > 0) {
              $.each(response.data, function (index, clip) {
                vm.books.push(clip);
              });
            } else {
              vm.allfatched = true;
            }
          });
          this.busy = false;
        }, 1000);
      }
    },
    checkSavedBook(id) {
      var vm = this; //declare this
      var status = false;

      if (this.loggedin_user && this.loggedin_user.saved_books.length > 0) {
        var saved_books = this.loggedin_user.saved_books;

        $.each(saved_books, function (index, book) {
          if (book.id == id) {
            status = true;
          }
        });
      }
      return status;
    },
  },
};
</script>